import 'numeral/locales/vi';
import CloseIcon from '@mui/icons-material/Close';
import LanguageIcon from '@mui/icons-material/Language';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  Tooltip,
} from '@mui/material';
import React, {useState} from 'react';

import i18n from '@explorer/i18n.js';

const LANGUAGES = ['en', 'pirate'];

const LocaleModal = () => {
  const [open, setOpen] = useState(false);

  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Tooltip title="Select Language" placement="right">
        <IconButton
          onClick={handleOpen}
          sx={{
            borderRadius: 1,
            margin: theme => theme.spacing(1, 0),
          }}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle sx={{pt: 0, pl: 0, pr: 8}}>
          Select Language
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box sx={{display: 'flex', flexDirection: 'column'}}>
          {LANGUAGES.map(lang => (
            <Button key={lang} onClick={() => changeLanguage(lang)}>
              {lang}
            </Button>
          ))}
        </Box>
      </Dialog>
    </div>
  );
};

export default LocaleModal;
